const prefix = 'pages.job-architecture-v2.profile-tasks.agents' as const;

export const recommendedAgentsTranslationKeys = {
    autonomy: `${prefix}.autonomy`,
    coverage: `${prefix}.coverage`,
    descriptionLevel: `${prefix}.description-level`,
    descriptionPosition: `${prefix}.description-position`,
    descriptionRole: `${prefix}.description-role`,
    empty: `${prefix}.empty`,
    emptyDescription: `${prefix}.empty-description`,
    error: `${prefix}.error`,
    hoursPerWeek: `${prefix}.hours-per-week`,
    leverAgenticAi: `${prefix}.lever-agentic-ai`,
    leverOtherTool: `${prefix}.lever-other-tool`,
    leverPhysicalAutomation: `${prefix}.lever-physical-automation`,
    leverSoftwareRpa: `${prefix}.lever-software-rpa`,
    loading: `${prefix}.loading`,
    recommendedFor: `${prefix}.recommended-for`,
    shareLevel: `${prefix}.share-level`,
    sharePosition: `${prefix}.share-position`,
    shareRole: `${prefix}.share-role`,
    tabAutomations: `${prefix}.tab-automations`,
    tabProfile: `${prefix}.tab-profile`,
    title: `${prefix}.title`,
} as const;

const libraryPrefix = `${prefix}.library` as const;

export const agentLibraryTranslationKeys = {
    architecture: `${libraryPrefix}.architecture`,
    architectureNone: `${libraryPrefix}.architecture-none`,
    attributionsError: `${libraryPrefix}.attributions-error`,
    attributionsLoading: `${libraryPrefix}.attributions-loading`,
    attributionsNotFound: `${libraryPrefix}.attributions-not-found`,
    autonomyOption: `${libraryPrefix}.autonomy-option`,
    clearFilter: `${libraryPrefix}.clear-filter`,
    columnAgent: `${libraryPrefix}.column-agent`,
    columnBusinessFunction: `${libraryPrefix}.column-business-function`,
    columnLevels: `${libraryPrefix}.column-levels`,
    columnPositions: `${libraryPrefix}.column-positions`,
    columnRoles: `${libraryPrefix}.column-roles`,
    count: `${libraryPrefix}.count`,
    empty: `${libraryPrefix}.empty`,
    emptyDescription: `${libraryPrefix}.empty-description`,
    emptyFiltered: `${libraryPrefix}.empty-filtered`,
    error: `${libraryPrefix}.error`,
    filterAutonomy: `${libraryPrefix}.filter-autonomy`,
    filterBusinessFunction: `${libraryPrefix}.filter-business-function`,
    filterLevel: `${libraryPrefix}.filter-level`,
    filterPosition: `${libraryPrefix}.filter-position`,
    filterRole: `${libraryPrefix}.filter-role`,
    kindJob: `${libraryPrefix}.kind-job`,
    kindPosition: `${libraryPrefix}.kind-position`,
    loading: `${libraryPrefix}.loading`,
    retry: `${libraryPrefix}.retry`,
    search: `${libraryPrefix}.search`,
    searchLevels: `${libraryPrefix}.search-levels`,
    searchPositions: `${libraryPrefix}.search-positions`,
    searchRoles: `${libraryPrefix}.search-roles`,
    title: `${libraryPrefix}.title`,
} as const;
